exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#logoBrand{max-width:150px}.navbar-item img{max-height:100%}.navbar.is-light{height:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c2f780d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sca_Componentes/tpa/cuartocontrol/layout/NavBar.vue
// module id = 3699
// module chunks = 0